import { render, staticRenderFns } from "./DsAppForm.vue?vue&type=template&id=336afb0a&scoped=true&"
import script from "./DsAppForm.vue?vue&type=script&lang=js&"
export * from "./DsAppForm.vue?vue&type=script&lang=js&"
import style0 from "./DsAppForm.vue?vue&type=style&index=0&id=336afb0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336afb0a",
  null
  
)

export default component.exports